import {
  createApolloClient,
  createPresetApolloClientOptions
} from "@gtech/preset-apollo-client";
import { Message } from "element-ui";
import router from "@root/router";

let isMainProject = process.env.VUE_APP_QIANKUN_APPLICATION_TYPE === "MAIN";
let main_apollo_url = isMainProject
  ? (window as any).__GTECH_VARIABLES_GRAPHQL_URL__
  : (window as any).__GTECH_VARIABLES_MAIN_APP_GRAPHQL_URL__;

let params: any = {
  expiredCode: "0002",
  errorHandler({
    response,
    message,
    code,
    networkError,
    firstExpired,
    expired
  }) {
    // 网络错误
    if (networkError) {
      Message.error("networkError");
      return;
    }

    // 首次过期
    if (firstExpired) {
      Message.error(message);

      // clear localstorage
      localStorage.clear();
      sessionStorage.clear();

      // qiankun 环境下
      router.push({ name: "Login" });

      return;
    }

    // 防止过期时 弹出多个提示
    if (expired) return;
    if (
      code === "wtcn.invalid-user-auth-token" ||
      code === "KOne.invalid-user-auth-token"
    ) {
      Message.error(message);

      localStorage.clear();
      sessionStorage.clear();

      // qiankun 环境下
      router.push({ name: "Login" });

      return;
    }

    const routeName = ["loginAccount", "Login"];
    const _name = router.currentRoute.name;
    if (!routeName.includes(_name)) {
      // 兼容抛错格式无message
      Message.error(message || code);
    }
  }
};

// pcr k1
export const K1_PCR_apolloClient = createApolloClient(
  createPresetApolloClientOptions({
    uri: main_apollo_url,
    setContextHeaders(headers) {
      headers["AUTH-TOKEN"] = localStorage.getItem("AUTH-TOKEN-K-ONE-CN");
      headers.appCode = (window as any).__GTECH_VARIABLES_MAIN_APP_CODE__;
      headers.Language = "zh-cn";
    },
    ...params
  })
);

// ygj k1
export const K1_YGJ_apolloClient = createApolloClient(
  createPresetApolloClientOptions({
    uri: (window as any).__GTECH_VARIABLES_GRAPHQL_URL_K_ONE_FRONTEND__,
    setContextHeaders(headers) {
      headers["AUTH-TOKEN"] = localStorage.getItem("AUTH-TOKEN-K-ONE-FRONTEND");
      headers.appCode = "K-ONE";
      headers.Language = "zh-cn";
    },
    ...params
  })
);
// tbr k1
export const K1_TBR_apolloClient = createApolloClient(
  createPresetApolloClientOptions({
    uri: (window as any).__GTECH_VARIABLES_GRAPHQL_URL_K_ONE_TBR__,
    setContextHeaders(headers) {
      headers["AUTH-TOKEN"] = localStorage.getItem("AUTH-TOKEN-K-ONE-TBR");
      headers.appCode = "WIN-TOGETHER-TBR";
      headers.Language = "zh-cn";
    },
    ...params
  })
);
